<div class="scheduler__flagged-agenda">
  <div class="scheduler__spinner text-center" *ngIf="loadEvents">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <p class="scheduler__agenda-error-no-events mt-2 px-2" *ngIf="errorNoEvents">
    No flagged events scheduled in the
    period
    {{currentDayFormatted}} - {{toDayFormatted}}.
  </p>
  <div *ngFor="let eventItem of eventslist" class="some-sticky-parent scheduler__agenda-element-{{calendarView}}"
    id="{{eventItem.CalendarDate.dayId}}">
    <div class="scheduler__agenda-day container-fluid some-sticky-element"
      [style]="calendarView === 'week' ? 'top: 188;position:sticky' : 'top: 324;position:sticky'">
      <div class="row">
        <div class="col-9">
          <span>{{eventItem.CalendarDate.relativeDay}}</span><span
            class="px-1">&bull;</span><span>{{eventItem.CalendarDate.formattedDate}}</span>
        </div>
        <div class="col-3 text-right"><span>WK {{eventItem.CalendarDate.weekNumber}}</span></div>
      </div>
    </div>
    <div class="container-fluid scheduler__event-tile">
      <div *ngIf="eventItem.EventsForDate.length === 0"
        class="row scheduler__event-tile-row scheduler__event-tile-row-empty">
        <p class="col mb-0 scheduler__event-empty-message">No events</p>
      </div>
      <div *ngFor="let event of eventItem.EventsForDate" class="row scheduler__event-tile-row">
        <div class="col-3">
          <p class="scheduler__event-time m-0 position-relative">
            <span *ngIf="event.shouldBeActive" class="scheduler__active-event"></span>
            {{event.StartTime}}
          </p>
          <p class="scheduler__event-subtime m-0">{{event?.duration}}</p>
        </div>
        <div class="col-7 pr-0">
          <div class="row">
            <div class="col-2 pl-0">
              <i class="scheduler__event-type-icon {{eventTypesIconClasses[event.EventType]}}"></i>
            </div>
            <div class="col-10 pl-1">
              <p class="m-0 scheduler__event-title">{{event.Title}}</p>
              <p class="m-0 scheduler__event-desc">{{event.Description}}</p>
            </div>
          </div>
        </div>
        <div class="col-1 text-right position-relative">
          <a *ngIf="!event.isPastEvent && event.IsDriverEvent" (click)="editEvent(event)" class="scheduler__event-edit">
            <i class="scheduler__event-edit-icon fas fa-pencil-alt"></i>
          </a>
        </div>
        <div class="col-1 text-right position-relative">
          <a  (click)="onCompleteEvent(event)"
            class="scheduler__event-edit">
            <i class="scheduler__event-complete-icon fas fa-check-circle"></i>
          </a>
        </div>
        <transflo-document-metadata [metadata]="documentMetadata" [documentName]="documentName" [showPopup]="showPopup"
          [eventId]="eventId" (close)="onClosePopup()" (submit)="onSubmitForm($event)">
        </transflo-document-metadata>
      </div>
    </div>
  </div>
</div>